import {fetch} from "utils/dataAccess";

export async function getFeedLog(productId) {
    const response = await fetch(`/products/${productId}/feed-logs`);

    return await response.json();
}
